var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletblacknew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    id: "wallet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M2 5.333c0 1.228.995 2.223 2.222 2.223h15.556c1.227 0 2.222.994 2.222 2.222v8.889a2.222 2.222 0 0 1-2.222 2.222H4.222A2.222 2.222 0 0 1 2 18.667V5.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M4.222 7.556h13.334V5.11a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v.222c0 1.228.995 2.223 2.222 2.223z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M22 17h-2.882a3.08 3.08 0 0 1-3.06-2.402A3.005 3.005 0 0 1 19 11h3v6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletblacknew);
export default __webpack_public_path__ + "static/media/walletblacknew.4dfd85b87516612bdb0dddb3c2b7240e.svg";
export { ForwardRef as ReactComponent };